import cn from 'classnames';
import { FieldValues, useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  getSMSCountry,
  getSupportedSMSCountriesOptions,
} from '$shared/utils/phone-number.utils';

import { Autocomplete } from '$components/autocomplete';

import infoItemStyles from '../../devices/device-information/info-item.module.scss';

import styles from './sms-country-dropdown.module.scss';

type ValueOf<T> = T[keyof T];

export function SMSCountrySelect<T extends FieldValues>({
  id,
  required,
}: {
  id: ValueOf<T>;
  required?: boolean;
}) {
  const { control } = useFormContext<T>();

  const { t } = useTranslation();

  return (
    <div
      className={cn(
        styles.wrapper,
        'color-gray-900',
        'body-regular',
        infoItemStyles.value,
      )}
    >
      <Controller
        control={control}
        rules={{ required }}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            className={styles.smsCountryAutocomplete}
            options={getSupportedSMSCountriesOptions()}
            value={getSMSCountry(value)}
            onChange={(option) => onChange(option.value)}
            placeholder={t('userManagement.countryCodeSelectPlaceHolder')}
            noOptionsMessage={() => t('deviceDetail.deviceInformation.noCountryOptions')}
            ariaLabelledBy="smscountry"
            menuPosition="top"
          />
        )}
        name={id}
      />
    </div>
  );
}
